import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { RootState } from '../reducers/rootReducer';
import { setDriverLogoffId, setDriverLogoffStatus } from '../actions/driverLogoff.actions';

import { CDRD_INTEGRATIONS_EGRESS_APIGEE_BASE_PATH, DRIVER_LOGOFF_APIGEE } from '../../constants';

import { ConfigAuthValues } from '../../types';

import { callAPI } from '../../utils';

const postDriverLogoff = (id: string, configAuthValues: ConfigAuthValues) => {
  const url = `${configAuthValues.APIGEE_BASE_URL}${CDRD_INTEGRATIONS_EGRESS_APIGEE_BASE_PATH}${DRIVER_LOGOFF_APIGEE}`;
  return callAPI({
    method: 'POST',
    url,
    data: { external_id: id },
  });
};

export function* runPostDriverLogoff(action: ReturnType<typeof setDriverLogoffId>) {
  const configAuthValues = yield select((state: RootState) => state.config.authValues);
  try {
    const result = yield call(postDriverLogoff, action.payload, configAuthValues);
    if (result.data.success) {
      yield put(setDriverLogoffStatus(result.data));
    } else {
      yield put(setDriverLogoffStatus({ success: false }));
    }
  } catch (error) {
    yield put(setDriverLogoffStatus({ success: false }));
  }
}

export default function* watchPostDriverLogoff() {
  yield takeEvery(getType(setDriverLogoffId), runPostDriverLogoff);
}
